import { call, put, takeLatest } from 'redux-saga/effects';
import { updateChangePin, updateActivateCard } from '../api';
import {
  changePinRequest,
  changePinSuccess,
  changePinFailed,
  activateCardRequest,
  activateCardSuccess,
  activateCardFailed,
} from '../reducer/changePinSlice';
import { isWeb } from '../storage';

interface ActivateCardRequestAction {
  type: typeof changePinRequest.type;
  payload: any;
}

interface ChangePinRequestAction {
  type: typeof changePinRequest.type;
  payload: any;
}

export function* activateCardSaga(
  action: ActivateCardRequestAction
): Generator<any, void, unknown> {
  try {
    const { accountId, customerId, requestBody } = action.payload;

    // Call the API to perform the Pin change
    const activateCardResponse: any = yield call(
      updateActivateCard,
      'activate_card_pin',
      accountId,
      customerId,
      requestBody
    );
    if (
      activateCardResponse?.activateResponse?.status === 'APPROVED' &&
      activateCardResponse?.setupPinResponse?.status === 'APPROVED'
    ) {
      yield put(activateCardSuccess(activateCardResponse?.activateResponse));
    } else {
        yield put(
          activateCardFailed(
            activateCardResponse?.title ? {
                status: activateCardResponse?.status || '500',
                detail: activateCardResponse?.detail || 'something went wrong',
                title: activateCardResponse?.title || 'unknown error',
            } : {
                status: '500',
                detail: 'something went wrong',
                title: 'unknown error',
              }
          )
        );
    }
  } catch (error: any) {
    yield put(
      activateCardFailed({
        status: '500',
        detail: 'something went wrong',
        title: 'unknown error',
      })
    );
  }
}

export function* changePinSaga(
  action: ChangePinRequestAction
): Generator<any, void, unknown> {
  try {
    const { accountId, customerId, requestBody } = action.payload;

    // Call the API to perform the Pin change
    const changePinResponse: any = yield call(
      updateChangePin,
      'change_pin',
      accountId,
      customerId,
      requestBody
    );
    if (changePinResponse?.statusCode === '200') {
      yield put(changePinSuccess(changePinResponse));
    } else {
      yield put(changePinFailed(changePinResponse));
    }
  } catch (error: any) {
    yield put(changePinFailed(error || 'Failed to change Pin'));
  }
}

export function* watchChangePinSaga() {
  yield takeLatest(activateCardRequest.type, activateCardSaga);
  yield takeLatest(changePinRequest.type, changePinSaga);
}
